<template>
  <b-card class="card-congratulation-medal">
    <template v-if="lastWeek">
      <h5>{{ lastWeek.week_name }}</h5>
      <b-card-text class="font-small-3">
        {{ formatPeriod(lastWeek.period) }} · {{ lastWeek.games_count }} игр · {{ lastWeek.players_count }} игроков
      </b-card-text>
      <h3 class="mb-75 mt-2 pt-50" :class="`text-${profitVariant(lastWeek.profit)}`">
        {{ formatRub(lastWeek.profit) }}
      </h3>
      <div class="d-flex flex-wrap align-items-center">
        <b-badge :variant="`light-${deltaVariant(delta.profit_pct)}`" class="mr-50 mb-50">
          прибыль {{ formatDelta(delta.profit_pct) }} к среднему
        </b-badge>
        <b-badge :variant="`light-${deltaVariant(delta.revenue_pct)}`" class="mb-50">
          выручка {{ formatDelta(delta.revenue_pct) }}
        </b-badge>
      </div>
      <b-button
        variant="primary"
        size="sm"
        class="mt-1"
        :to="{ name: 'finance-week-detail', params: { id: lastWeek.week_id } }"
      >
        Детали недели
      </b-button>
    </template>
    <div v-else class="text-muted py-3">
      Нет завершённых недель в снапшоте
    </div>
    <b-img :src="require('@/assets/images/illustration/badge.svg')" class="congratulation-medal" alt="Медаль" />
  </b-card>
</template>

<script>
import {
  BCard, BCardText, BButton, BImg, BBadge,
} from 'bootstrap-vue'
import { computed } from '@vue/composition-api'
import { formatRub, formatPeriod, profitVariant } from '@/views/finance/utils'
import { formatDelta, deltaVariant } from '@/views/dashboard/sifnf/utils'

export default {
  components: {
    BCard, BCardText, BButton, BImg, BBadge,
  },
  props: {
    business: { type: Object, default: null },
  },
  setup(props) {
    const lastWeek = computed(() => (props.business && props.business.last_week) || null)
    const delta = computed(() => (props.business && props.business.delta) || {})
    return {
      lastWeek, delta, formatRub, formatPeriod, profitVariant, formatDelta, deltaVariant,
    }
  },
}
</script>
